import { render } from "./EconomicIndicatorChildRows.vue?vue&type=template&id=4b3f425f&scoped=true"
import script from "./EconomicIndicatorChildRows.vue?vue&type=script&lang=js"
export * from "./EconomicIndicatorChildRows.vue?vue&type=script&lang=js"

import "./EconomicIndicatorChildRows.vue?vue&type=style&index=0&id=4b3f425f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3f425f"]])

export default __exports__